/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { func } from 'prop-types';

import p from 'polyglot/polyglot';

import {
  CLIENT,
  TALENT_TYPES,
  HAIR_STYLIST,
  MAKEUP_STYLIST,
  HEAD_STYLIST,
} from 'actions/signup';

import Button from 'components/Button/Button';

import styles from './choose-type.scss';
import classNames from 'clsx';

/**
 * This is the ChooseType component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class ChooseType extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    setSignupType: func.isRequired,
  };

  state = {
    type: '',
    error: false,
  };

  onChange = e => {
    const { value: type } = e.target;

    this.setState({
      type,
      error: false,
    });
  };

  onClick = e => {
    e.preventDefault();

    const { type } = this.state;
    const { setSignupType } = this.props;

    const signupType = [HAIR_STYLIST, MAKEUP_STYLIST].includes(type)
      ? HEAD_STYLIST
      : type;

    if (!signupType) {
      return this.setState({
        error: true,
      });
    }

    setSignupType(signupType);
  };

  /**
   * Render ChooseType.
   *
   * @return {Object}
   */
  render() {
    const { type, error } = this.state;

    const options = {};

    TALENT_TYPES.map(type => {
      options[type] = p.t(`signup.talent_type.types.${type.toLowerCase()}`);
    });

    options[CLIENT] = p.t('signup.button.client');

    return (
      <article>
        <h2 className={styles.title}>{p.t('signup.choose_type.title')}</h2>
        <p className={styles.tagline}>{p.t('signup.choose_type.tagline')}</p>

        <p className={styles.label}>
          {p.t('signup.choose_type.form.type.label')}
        </p>

        <div className={styles.select}>
 
          {TALENT_TYPES.map((talentType, index) => {

            const active = talentType === type;
            
            return <button 
                name="signup-modal-select-type"
                type="button" 
                value={talentType} 
                onClick={this.onChange} 
                className={classNames(styles.options, {
                  [styles.active]: active,
                })}
                key={index}>{options[talentType]} </button>
          })}
        </div>

        <footer className={styles.footer}>
          <Button disabled={type === ""} 
            dark
            ghost
            onClick={this.onClick}>
            {p.t('general.next')}
          </Button>
        </footer>
      </article>
    );
  }
}
